import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';



const Page = ({ children }) => {
  const theme = useTheme();
  const mediumUp = useMediaQuery(theme.breakpoints.up('sm'));
  
  const mainStyles = mediumUp ? { marginTop: '75px' } : { marginTop: '50px' };
  
  return (
    <main style={mainStyles}>
      {children}
    </main>
  )
}

export default Page;